"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var PurchaseView = function () {
    var _a;
    var id = "react-open-modal-purchase";
    var node = (0, react_1.useRef)(document.getElementById(id));
    var modal = (0, react_1.useRef)(document.getElementById("open-modal-purchase"));
    var modalClose = (0, react_1.useRef)(document.getElementById("close-modal-purchase"));
    var flagOpen;
    var _b = (0, react_1.useState)(false), isShowPurchase = _b[0], setIsShowPurchase = _b[1];
    function handleClick() {
        if (flagOpen) {
            js_cookie_1.default.set('open-puchase-flag', false);
        }
        setIsShowPurchase(function (prev) { return !prev; });
    }
    (0, react_1.useEffect)(function () {
        var el = document.getElementById(id);
        if (el)
            node.current = el;
        var _modal = document.getElementById("open-modal-purchase");
        if (_modal) {
            modal.current = _modal;
            var flagOpenNode = modal.current.getAttribute("data-flag-open");
            if (flagOpenNode) {
                flagOpen = parseInt(flagOpenNode);
                var cookieFlag = js_cookie_1.default.get('open-puchase-flag');
                if (flagOpen && cookieFlag === undefined) {
                    setIsShowPurchase(true);
                }
            }
        }
        var _modalClose = document.getElementById("close-modal-purchase");
        if (_modalClose) {
            modalClose.current = _modalClose;
            modalClose.current.onclick = function () {
                if (flagOpen) {
                    js_cookie_1.default.set('open-puchase-flag', false);
                }
                setIsShowPurchase(false);
            };
        }
    }, []);
    (0, react_1.useEffect)(function () {
        console.log("isShowPurchase", isShowPurchase);
        if (isShowPurchase) {
            if (modal.current) {
                modal.current.style.display = "block";
            }
        }
        else {
            if (modal.current)
                modal.current.style.display = "none";
        }
    }, [isShowPurchase]);
    return (react_1.default.createElement("a", { style: { marginLeft: "auto" }, onClick: handleClick, href: "#" }, (_a = node.current) === null || _a === void 0 ? void 0 : _a.getAttribute("title")));
};
exports.default = PurchaseView;
